import {Component} from '@angular/core';
import {TreeNode} from '../../../../../content/shared/interfaces/tree-node.interface';
import {BaseTreeNodeComponent} from '../base-tree-node/base-tree-node.component';

/**
 * Class for the CheckboxTreeNodeComponent
 * @class CheckboxTreeNodeComponent
 *
 * @description Checkbox tree node implementation. Used to facilitate multiple selection in a tree list
 *
 *
 * @usage
 *
 * ```html
 *
 * <advtech-checkbox-tree-node
 *  [node]='node'
 *  [isChild]='true'
 *  [value]='value'
 *  (onTreeNodeSelection)='hTreeNodeSelection($event, node)'
 * ></advtech-checkbox-tree-node>
 * ```
 *
 * # Inputs
 *
 * |name|type|description|
 * |---|---|---|
 * |node|[[TreeNode]]|The node value for this tree node|
 * |isChild|boolean|Is this a child of another node|
 * |value|[[TreeNode]][]|The current value for the input|
 *
 * # Outputs
 *
 * |name|type|description
 * |---|---|---|
 * |onTreeNodeSelection|[EventEmitter]{@link https://angular.io/api/core/EventEmitter}<{value}>|Emits the selected node
 */
@Component({
  selector: 'advtech-checkbox-tree-node',
  templateUrl: './checkbox-tree-node.component.html',
})
export class CheckboxTreeNodeComponent extends BaseTreeNodeComponent {
  /**
   * Emits the tree node selection. Overrides it's parent to pass the 'checked' value through
   * @param {any} e Value from the ionic input
   * @param {TreeNode} node The tree node
   * @returns {void}
   */
  hTreeNodeSelection(e: any, node: TreeNode): void {
    const value = e.value && this.isTreeNode(e.value) ? e.value : node;
    if ('checked' in e) {
      value.checked = e.checked;
    }
    else if (e.target && e.target.parentElement) {
      value.checked = e.target.parentElement.getAttribute('aria-checked') !== 'true';
    }
    this.onTreeNodeSelection.emit({value});
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/tree/tree-node/checkbox-tree-node/checkbox-tree-node.component.ts